import { Pipe, PipeTransform } from '@angular/core';

interface Phone {
  country: string;
  city: string;
  phoneNumber: string;
}

@Pipe({
  name: 'phone',
  standalone: false,
})
export class PhonePipe implements PipeTransform {
  private static splitInformation(value: string): Phone | null {
    switch (value.length) {
      case 10: // +1PPP####### -> C (PPP) ###-####
        return {
          country: '1',
          city: value.slice(0, 3),
          phoneNumber: value.slice(3),
        };
      case 11: // +CPPP####### -> CCC (PP) ###-####
        return {
          country: value[0],
          city: value.slice(1, 4),
          phoneNumber: value.slice(4),
        };
      case 12: // +CCCPP####### -> CCC (PP) ###-####
        return {
          country: value.slice(0, 3),
          city: value.slice(3, 5),
          phoneNumber: value.slice(5),
        };
      default:
        return null;
    }
  }

  transform(value: string): string {
    if (value && value.match(/\d+/g)) {
      value = value.toString().trim().replace(/^\+/, '');
    } else {
      return value;
    }

    const phone = PhonePipe.splitInformation(value);
    if (!phone) {
      return value;
    }

    if (phone.country === '1') {
      phone.country = '';
    }

    phone.phoneNumber = phone.phoneNumber.slice(0, 3) + '-' + phone.phoneNumber.slice(3);

    return `${phone.country} (${phone.city}) ${phone.phoneNumber}`.trim();
  }
}
